import React, { useState } from 'react';
import GradientButton from './common/GradientButton';
import AuthDebugger from './AuthDebugger';

const Footer = () => {
  const [showAuthDebugger, setShowAuthDebugger] = useState(false);
  return (
    <footer className="p-6 flex justify-center ">
      <div className="w-full bg-blue-500 h-12">
        <h1 className="text-white py-4"></h1>
      </div>
      <div className="w-full bg-blue-500 h-12">
        <h1 className="text-white text-center py-4">ConversantBT</h1>
      </div>
      <div className="w-full bg-blue-500 h-12 ">
        <h1 className="text-white text-right py-4">
          Info@conversantbt.com &nbsp;
        </h1>
      </div>
    </footer>
  );
};

export default Footer;
